module.exports = __webpack_public_path__ + "static/media/background.4f20a173.jpg";